import IInputChangeHandler from '../IInputChangeHandler';
import SelectInput from '../controls/SelectInput';
import type StateFilteredAddress from './StateFilteredAddress';

export default class StateFilteredAddressInputChangeHandler implements IInputChangeHandler {
  input: SelectInput;

  stateFilter: StateFilteredAddress;

  constructor(input: SelectInput, stateFilter: StateFilteredAddress) {
    this.input = input;
    this.stateFilter = stateFilter;
  }

  start() {
    this.input.$inputs[0].addEventListener('change', this.onChange);
  }

  stop(): void {
    this.input.$inputs[0].removeEventListener('change', this.onChange);
  }

  onChange = () => {
    this.stateFilter.update();
  };
}
